<template>
  <div>
    <div class="career">
      <Hero :backImg="require('../../assets/img/career/hero.jpg')" :backImgSp="require('../../assets/img/career/hero_sp.jpg')" alt="" title="キャリアステップ" text="クレハでは、出身学部や研究分野に関わらず、<br>適性や希望に合わせて一人ひとりが成長できる環境を整えています。<br>ここではクレハで描けるキャリアの一例をご紹介します。" />
      <section class="contents">
        <div class="introduction">
          クレハは、独創的な製品を数多く創出している技術開発型企業。<br>
          国内外の様々なお客様から高い信頼を得る「エクセレント・カンパニー」を目指し、<br>
          一人ひとりが若いうちから責任とやりがいを持って活躍してほしいと考えています。
        </div>
        <h3 class="page-title">
          キャリアケース
        </h3>
        <div class="tab-wrapper">
          <div @click="openTabContents(1)" :class="[{'active': openTab == 1},'lab tab']">
            研究・技術職種
          </div>
          <div @click="openTabContents(2)" :class="[{'active': openTab == 2},'gen tab']">
            企画・営業職種
          </div>
        </div>
        <div v-if="openTab == 1" class="case-wrapper lab">
          <Case :profileImg="require('../../assets/img/career/lab/profile01.jpg')" :caseImg="require('../../assets/img/career/lab/figure01.png')" :caseImgSp="require('../../assets/img/career/lab/figure01_sp.png')" link="/newgraduate/lab/staff/06" />
          <Case :profileImg="require('../../assets/img/career/lab/profile02.jpg')" :caseImg="require('../../assets/img/career/lab/figure02.png')" :caseImgSp="require('../../assets/img/career/lab/figure02_sp.png')" link="/newgraduate/lab/staff/05" />
          <Case :profileImg="require('../../assets/img/career/lab/profile03.jpg')" :caseImg="require('../../assets/img/career/lab/figure03.png')" :caseImgSp="require('../../assets/img/career/lab/figure03_sp.png')" link="/newgraduate/lab/staff/02" />
          <Case :profileImg="require('../../assets/img/career/lab/profile04.jpg')" :caseImg="require('../../assets/img/career/lab/figure04.png')" :caseImgSp="require('../../assets/img/career/lab/figure04_sp.png')" link="/newgraduate/lab/staff/04" />
          <div class="another_case">
            <picture>
              <source srcset="../../assets/img/career/lab/figure05.png"
                      media="(min-width: 768px)">
              <source srcset="../../assets/img/career/lab/figure05_sp.png"
                      media="(max-width: 767px)">
              <img src="../../assets/img/career/lab/figure05.png" alt="">
            </picture>
          </div>
        </div>
        <div v-else-if="openTab == 2" class="case-wrapper gen">
          <Case :profileImg="require('../../assets/img/career/gen/profile01.jpg')" :caseImg="require('../../assets/img/career/gen/figure01.png')" :caseImgSp="require('../../assets/img/career/gen/figure01_sp.png')" link="/newgraduate/gen/staff/01" />
          <Case :profileImg="require('../../assets/img/career/gen/profile02.jpg')" :caseImg="require('../../assets/img/career/gen/figure02.png')" :caseImgSp="require('../../assets/img/career/gen/figure02_sp.png')" link="/newgraduate/gen/staff/03" />
          <div class="another_case">
            <picture>
              <source srcset="../../assets/img/career/gen/figure03.png"
                      media="(min-width: 768px)">
              <source srcset="../../assets/img/career/gen/figure03_sp.png"
                      media="(max-width: 767px)">
              <img src="../../assets/img/career/gen/figure03.png" alt="">
            </picture>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
import Case from '@/components/career/Case.vue';
export default {
  name: 'career',
  components: {
    Hero,
    Case
  },
  data() {
    return {
      openTab: 1,
    }
  },
  methods: {
    openTabContents(number) {
      this.openTab = number;
    },
  }
}
</script>

<style lang="scss" scoped>
.contents {
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding: 100px 0 150px 0;
  @media print, screen and (max-width: 768px) {
    padding: 50px 0 100px 0;
  }
}
.introduction {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #3fae00;
  @media print, screen and (max-width: 768px) {
    font-size: 16px;
  }
}
.page-title {
  position: relative;
  left: 0;
  background-color: #3fae00;
  color: #fff;
  font-weight: bold;
  @media print,screen and (min-width: 1001px) {
    font-size: 40px;
    display: inline-block;
    padding-left: calc((100vw - 1000px) / 2);
    left: calc((-100vw + 1000px) / 2);
    margin: 100px 0;
    padding: 0 30px;
  }
  @media print,screen and (max-width: 1000px) {
    text-align: center;
    font-size: 20px;
    width: 110%;
    margin-left: -5%;
    margin-top: 50px;
  }
  p {
    margin: 0;
  }
}
.tab-wrapper {
  display: flex;
  max-width: 840px;
  margin: 0 auto;
  justify-content: space-between;
  margin-top: 50px;
  .tab {
    cursor: pointer;
    width: calc(50% - 10px);
    font-size: 26px;
    background-color: #9e9e9e;
    color: #fff;
    border-radius: 5px 5px 0px 0px;
    text-align: center;
    font-weight: bold;
    @media print, screen and (max-width: 414px) {
      font-size: 16px;
      width: calc(50% - 2px);
    }
    &.lab.active{
      background-color: #00797f;
    }
    &.gen.active {
      background-color: #3fae00;
    }
  }
}
.case-wrapper {
  width: 100%;
  margin: 0 auto;
  &.lab {
    border-top: 2px solid #00797f;
  }
  &.gen {
    border-top: 2px solid #3fae00;
  }
}
.another_case {
  max-width: 840px;
  width: 100%;
  margin: 0 auto;
  margin-top: 100px;
  @media print, screen and (max-width: 767px) {
    width: 80%;
  }
}
</style>
